import { formatDate } from '@/utils/formatDate'
import BigCard from '../common/card/BigCard'
import type { NoticeListItem } from '@/api/model/noticeType'

interface INoticeDetailScreen {
  notice: NoticeListItem | null
}

const NoticeDetailScreen = ({ notice }: INoticeDetailScreen) => {
  return (
    <>
      {notice ? (
        <div className='min-h-screen '>
          {/* 메인 콘텐츠 */}
          <div className='px-3 pb-32 pt-3'>
            <BigCard className=' overflow-hidden p-5'>
              {/* 알림 제목 및 기본 정보 */}
              <div className='mb-6'>
                <h2 className='text-xl font-bold text-gray-800 mb-2'>{notice.title}</h2>
                <p className='text-gray-500 text-sm'>{formatDate(notice.created_at)}</p>
              </div>

              {/* 알림 내용 */}
              <div className='space-y-4'>
                {notice.content?.split('\n').map((line, index) => (
                  <p key={index} className='text-gray-700 leading-relaxed text-sm'>
                    {line}
                  </p>
                ))}
              </div>
            </BigCard>
          </div>
        </div>
      ) : (
        <div>
          <h1>알림이 없습니다.</h1>
        </div>
      )}
    </>
  )
}

export default NoticeDetailScreen
